import React from "react";
import "./topbar.css";
import Logo from "./logo.png";
import { Language, Settings } from "@material-ui/icons";
import LogoutIcon from "@mui/icons-material/Logout";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';


export default function Topbar() {
  const dispatch = useDispatch();
  const {isAdmin } = useSelector((state) => state.auth);
  const history = useHistory();



  const logout = async () => {
    await dispatch({ type: "LOGOUT" });
    // toggleDelete();
    history.push("/login");
  };
  return (
    <div className="topbar">
      <div className="topbarWrapper">
        <div className="topLeft">
        <span className="adminHead">
            {isAdmin ? 'ADMIN DASHBOARD' : 'USER DASHBOARD'}
          </span>
        </div>
        <div className="topLeft">
          <img className="logo" src={Logo} alt="Brand Logo" />
          <h3 className="logoname">LAXSTATCLOCK</h3>
        </div>
        <div className="topRight">
          <div className="topbarIconContainer">
            <Settings />
          </div>
          <div className="topbarIconContainer">
            <button
              onClick={logout}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: "white",
                cursor: "pointer",
              }}
            >
              {" "}
              <LogoutIcon />{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
